function initializeProductSwipers(context = document) {
  // Find the containers in the given context (document or modal)
  var thumbsEl = context.querySelector(".mySwiper");
  var mainEl = context.querySelector(".mySwiper2");

  // Only initialize if both elements exist
  if (!thumbsEl || !mainEl) return;

  var thumbsSwiper = new Swiper(thumbsEl, {
    loop: true,
    spaceBetween: 10,
    slidesPerView: 5,
    freeMode: true,
    pauseOnMouseEnter: false,
    watchSlidesProgress: true,
  });

  var mainSwiper = new Swiper(mainEl, {
    loop: true,
    spaceBetween: 10,
    pauseOnMouseEnter: false,
    navigation: {
      nextEl: context.querySelector(".swiper-button-next"),
      prevEl: context.querySelector(".swiper-button-prev"),
    },
    thumbs: {
      swiper: thumbsSwiper,
    }
  });

  let autoplayInterval;

 function startAutoplay() {
    stopAutoplay(); // Prevent multiple intervals
    autoplayInterval = setInterval(() => {
      mainSwiper.slideNext();
    }, 3000);
  }

 function stopAutoplay() {
    if (autoplayInterval) clearInterval(autoplayInterval);
  }

  // Expose so other scripts (e.g. the variant-image-swap script) can pause
  // autoplay while they programmatically move the slider.
  window.pdpMediaAutoplay = window.pdpMediaAutoplay || {};
  window.pdpMediaAutoplay.stop = stopAutoplay;
  window.pdpMediaAutoplay.start = startAutoplay;
  window.pdpMediaAutoplay.mainSwiper = mainSwiper;
  window.pdpMediaAutoplay.thumbsSwiper = thumbsSwiper;

  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  if (!isMobile) {

  startAutoplay();

    const swiperContainers = context.querySelectorAll('.mySwiper2, .mySwiper');
    swiperContainers.forEach(container => {
      container.addEventListener('mouseenter', stopAutoplay);
      container.addEventListener('mouseleave', startAutoplay);
    });

    mainSwiper.on('touchStart', stopAutoplay);
    thumbsSwiper.on('touchStart', stopAutoplay);
  }
}

function initializeZoom(context = document) {
  const zoomScale = 1.5;
  context.querySelectorAll(".mediaThumbzoom-image").forEach((img) => {
    const container = img.closest(".mediaThumbzoom-container");
    let isZoomed = false;

    container.addEventListener("click", function (e) {
      isZoomed = !isZoomed;
      if (isZoomed) {
        const rect = container.getBoundingClientRect();
        const offsetX = e.clientX - rect.left;
        const offsetY = e.clientY - rect.top;
        const percentX = (offsetX / rect.width) * 100;
        const percentY = (offsetY / rect.height) * 100;
        img.style.transformOrigin = `${percentX}% ${percentY}%`;
        img.style.transform = `scale(${zoomScale})`;
      } else {
        img.style.transform = "scale(1)";
        img.style.transformOrigin = "center center";
      }
    });

    container.addEventListener("mousemove", function (e) {
      if (!isZoomed) return;
      const rect = container.getBoundingClientRect();
      const offsetX = e.clientX - rect.left;
      const offsetY = e.clientY - rect.top;
      const percentX = (offsetX / rect.width) * 100;
      const percentY = (offsetY / rect.height) * 100;
      img.style.transformOrigin = `${percentX}% ${percentY}%`;
    });

    container.addEventListener("mouseleave", function () {
      if (isZoomed) {
        img.style.transform = "scale(1)";
        img.style.transformOrigin = "center center";
        isZoomed = false;
      }
    });
  });
}



function buyCustomButton(context = document) {

  document.querySelectorAll('.pdpBuy-btn').forEach(button => {
  button.addEventListener('click', function () {
    const addToCartForm = this.closest('form[action$="/cart/add"]');

    if (!addToCartForm) {
      console.error('Add to Cart form not found for this button!');
      return;
    }

    const formData = new FormData(addToCartForm);
    formData.set('quantity', '1'); // Force quantity to 1

    // Step 1: Clear the cart
    fetch(window.Shopify.routes.root + 'cart/clear.js', {
      method: 'POST',
      headers: {
        'Accept': 'application/json'
      }
    })
    .then(() => {
      // Step 2: Add new product
      return fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json'
        }
      });
    })
    .then(response => {
      if (response.ok) {
        // Step 3: Redirect to checkout
        window.location.href = '/checkout';
      } else {
        return response.json().then(err => {
          throw new Error(err.description || 'Error adding product.');
        });
      }
    })
    .catch(error => {
      console.error('Error:', error);
      alert('Please select a valid product option before proceeding.');
    });
  });
});



}

// On page load
document.addEventListener("DOMContentLoaded", function () {
  initializeZoom(document);
});

document.addEventListener("DOMContentLoaded", function () {
  initializeProductSwipers(document);
});


document.addEventListener("DOMContentLoaded", function () {
  buyCustomButton(document);
});


// In modal, after content is set
if (typeof initializeZoom === "function") {
  initializeZoom(this.modalContent);
}

if (typeof initializeProductSwipers === "function") {
  initializeProductSwipers(this.modalContent);
}

if (typeof buyCustomButton === "function") {
  buyCustomButton(this.modalContent);
}